import React from 'react';
import { motion } from 'framer-motion';
import { XIcon } from 'lucide-react';
import { PAIN_POINTS } from './salesData';
export function PainSection() {
  return <section className="bg-ivory py-12 sm:py-16" data-id="element-150" data-mp="38vki6mduy1yy">
      <div className="mx-auto max-w-3xl px-5 text-center" data-id="element-151" data-mp="2ux40y1idct2k">
        <h2 className="font-display text-[1.7rem] font-semibold leading-tight text-charcoal sm:text-[2.4rem]" data-id="element-152" data-mp="2yzqty5qs0k1c">
          ¿Cuántos domingos más vas a perder así?
        </h2>
        <p className="mx-auto mt-4 max-w-2xl text-sm leading-relaxed text-charcoal/70 sm:text-base" data-id="element-153" data-mp="2l69ccqhnhhdy">
          Sos profesional del bienestar. Amás lo que hacés. Pero nadie te dijo que ibas a pasar los
          domingos pensando qué publicar, armando stories que no convierten y respondiendo mensajes
          con solo el precio esperando que alguien se inscriba.
        </p>
        <p className="mt-4 font-display text-lg font-semibold text-gold-deep sm:text-xl" data-id="element-154" data-mp="22at3gzq2789z">
          No es falta de talento. Es falta de un sistema.
        </p>

        <ul className="mx-auto mt-7 grid gap-2 text-left sm:grid-cols-2" data-id="element-155" data-mp="3rmhn0z7xxq7x">
          {PAIN_POINTS.map((p, i) => <motion.li key={i} initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-40px'
        }} transition={{
          duration: 0.35,
          delay: i * 0.05
        }} className="flex items-start gap-2.5 rounded-lg border border-stone bg-sand/60 px-3.5 py-2.5" data-id="element-156" data-mp="3nm74kn2yp7c6" data-mpi={i}>
              <XIcon className="mt-0.5 h-4 w-4 shrink-0 text-charcoal/50" aria-hidden data-id="element-157" data-mp="33xyeqjow5dfu" />
              <span className="text-[0.82rem] leading-snug text-charcoal/75" data-id="element-158" data-mp="3imchkumb51we">{p}</span>
            </motion.li>)}
        </ul>

        <p className="mt-8 font-display text-xl font-semibold italic text-charcoal sm:text-2xl" data-id="element-159" data-mp="3dukx91tqvsep">
          ¿Y si este fuera el último domingo que pasás así?
        </p>
      </div>
    </section>;
}